<template>
  <figure
    class="avatar"
    :class="{
      light: light,
      icon: imageError || (!imgName && !extImg),
    }"
  >
    <img
      v-if="!imageError && (imgName || extImg)"
      class="image"
      :src="extImg || require(`../../assets/media/avatars/${imgName}`)"
      :alt="$t('general.alt-avatar-du-compte')"
      @error="imageError = true"
    />
    <UilUser v-else />
    <Counter
      v-if="notification > -1"
      :value="notification"
      size="small"
    />
  </figure>
</template>

<script>
import Counter from "../../components/infos/Counter.vue";

import { UilUser } from "@iconscout/vue-unicons";

/**
 * Affiche une image de profil avec éventuellement un indicateur de notification.
 */
export default {
  name: "Avatar",
  components: {
    Counter,
    UilUser,
  },
  props: {
    /**
     * Image externe au site avec son extension.
     */
    extImg: {
      type: String,
      default: null,
    },
    /**
     * Image intégrée au site avec son extension.
     */
    imgName: {
      type: String,
      default: null,
    },
    /**
     * Nombre de notification(s).
     */
    notification: {
      type: Number,
      default: -1,
    },
    /**
     * Couleur du contour de l'avatar (uniquement avec une image).
     */
    light: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageError: false,
    };
  },
  watch: {
    extImg() {
      this.imageError = false;
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/avatar/avatar.scss";
</style>
